import { post, get } from '@/helpers/HttpHelper'

export class RegistrarService {
  async registrar (formData) {
    const response = await post('/cliente/registrar', formData)
    return response.data
  }

  async getDepartamentos () {
    const response = await get('ubigeo/departamentos')
    return response.data.data
  }

  async getProvincias (departamentoId) {
    const response = await get(`ubigeo/provincias/${departamentoId}`)
    return response.data.data
  }

  async getDistritos (provinciaId) {
    const response = await get(`ubigeo/distritos/${provinciaId}`)
    return response.data.data
  }

  async quieroCotizacion (formData) {
    const response = await post('/cliente/quiero_cotizacion', formData)
    return response.data
  }

  async suscribirse (formData) {
    const response = await post('/cliente/suscribirse', formData)
    return response.data
  }

  async registrarUf (formData) {
    const response = await post('/cliente/registrarUf', formData)
    return response.data
  }

  async contactanos (formData) {
    const response = await post('/cliente/contactanos', formData)
    return response.data
  }
}
